import { useField } from 'formik'
import React from 'react'
import { Form } from 'semantic-ui-react'
import FWOLabel from './FWOLabel'

interface Props {
  placeholder?: string
  name: string
  type?: string
  label?: string
  ariaLabel?: string
  tooltip?: string
  htmlTooltip?: string
  defaultHtmlTooltipIconText?: string
  title?: string
  required: boolean
  showreadonly?: boolean
  showOptional?: boolean
  limit?: number
  desc?: string
}

const FWOTextInput = (props: Props) => {
  const [field, meta, helpers] = useField(props.name)
  const setFormattedContent = (text) => {
    if (text === undefined) {
      return
    }
    helpers.setValue(text.slice(0, props.limit))
  }
  const hasError = meta.touched && !!meta.error
  return (
    <Form.Field error={hasError} {...{ required: props.required }}>
      <div className={`sixteen wide field`}>
        <FWOLabel
          label={props.label}
          name={props.name}
          showOptional={props.showOptional}
          required={props.required}
          tooltip={props.tooltip?.split('<br/>').join('\n')}
          htmlTooltip={props.htmlTooltip}
          defaultHtmlTooltipIconText={props.defaultHtmlTooltipIconText}
        />
        {props.desc && <p>{props.desc}</p>}
        {hasError ? (
          <span className="validation-error">{meta.error}</span>
        ) : null}
        <input
          {...field}
          {...{
            name: props.name,
            type: props.type,
            label: props.label,
            placeholder: props.placeholder,
          }}
          title={`${props.title == null ? '' : props.title}`}
          aria-label={hasError ? props.ariaLabel + meta.error : props.ariaLabel}
          onChange={(event) => setFormattedContent(event.target.value)}
          {...{ readOnly: props.showreadonly == true }}
          onKeyPress={(e) => {
            e.which === 13 && e.preventDefault()
          }}
        />
      </div>
    </Form.Field>
  )
}

export default FWOTextInput
